import React from 'react';
import { 
  Box, 
  Container, 
  Typography, 
  CircularProgress, 
  Button,
  Paper
} from '@mui/material';

import { useSelector } from 'react-redux';

const getColorFromScore = (score) => {
  // Ensure the score is within bounds
  const clampedScore = Math.max(0, Math.min(score, 100));

  // Calculate the green and red components
  const green = Math.round((clampedScore / 100) * 255);
  const red = Math.round(((100 - clampedScore) / 100) * 255);

  // Convert RGB to hexadecimal
  const toHex = (value) => {
    const hex = value.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
  };

  return `#${toHex(red)}${toHex(green)}00`;
};

const ScoreDisplay = ({ score }) => {
  const dynamicColor = getColorFromScore(score);

  return (
  <Box 
    sx={{
      position: 'relative',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}
  >
    <CircularProgress
      variant="determinate"
      value={score}
      size={160}
      thickness={4}
      sx={{ color: dynamicColor }}
    />
    <Box
      sx={{
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        variant="h3"
        component="div"
        color="text.primary"
      >
        {score}
      </Typography>
    </Box>
  </Box>
)};

function PublicScore() {
  const score = useSelector((state) => state.public.publicScore);
  const fetchStatus = useSelector((state) => state.public.fetchStatus);
  const error = useSelector((state) => state.public.error);
    if (fetchStatus === 'loading') {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (score === null) {
    return <div>No score available</div>;
  }

  const roundedScore = Math.round(score * 100) / 100;

  return (
    <Container 
      maxWidth="sm" 
      sx={{
        py: 8,
        mt: 10,
      }}
    >
      <Paper elevation={2} sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4" gutterBottom>
          Your Portfolio Score
        </Typography>
        
        <Box sx={{ my: 4, display: 'flex', justifyContent: 'center' }}>
          <ScoreDisplay score={roundedScore} />
        </Box>

        <Typography variant="body1" color="text.secondary" paragraph>
          Your dividend portfolio is performing better than {roundedScore}% of investors
        </Typography>

        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            size="large"
            href="/signup/premium"
            sx={{ minWidth: 200 }}
          >
            See How to Improve
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}

export default PublicScore;